import {get as _get, find as _find, random as _random} from 'lodash';

import initialState from '../initialstate';

import {
	GET_GS_SCOPES,
	GET_GS_INSTRUCTIONS_DATA,
	GET_GS_TASKS_DATA,
	GET_GS_TEAMS_DATA,
	RESET_GS_TAB_DATA
} from '../../actions/actiontypes';

import {HttpStatusCodes} from '../../util/uiconstants';
import normalizeTeamsData from './normalizeTeamsData';
import normalizeScopeTeamList from './normalizeScopeTeamList';
import resetTabsData from './resetTabsData';
import normalizeScopeInstructionList from './normalizeScopeInstructionsList';
import normalizeInstruction from './normalizeInstruction';
import normalizeScopesSummary from './normalizeScopesSummary';
import normalizeScopeTasksList from './normalizeScopeTasksList';

export default function GSScopesReducer(state = initialState.gsScopes, action) {
	switch (action.type) {
		case GET_GS_SCOPES: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const scopes = _get(action, 'response', []);
				return normalizeScopesSummary(scopes);
			}
			return state;
		}
		case GET_GS_INSTRUCTIONS_DATA: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				const scopeId = action.scopeId;
				if (scopeId) {
					return normalizeScopeInstructionList(state, scopeId, normalizeInstruction(data));
				}
			}
			return state;
		}
		case GET_GS_TASKS_DATA: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				const scopeId = action.scopeId;
				if (scopeId) {
					return normalizeScopeTasksList(state, scopeId, normalizeInstruction(data));
				}
			}
			return state;
		}
		case GET_GS_TEAMS_DATA: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', {gaScopeId: null});
				if (data.gaScopeId >= 0) {
					const teamsData = normalizeTeamsData(data.teamList);
					return normalizeScopeTeamList(state, data.gaScopeId, teamsData);
				}
			}
			return state;
		}
		case RESET_GS_TAB_DATA: {
			const targetScope = _get(action, 'scopeId', null);
			return targetScope ? resetTabsData(state, targetScope) : state;
		}
		default:
			return state;
	}
}
